import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import { apiFetchIATAList, apiDeactivateFlight, apiFetchManualFlightById } from '../../api/FlightInformationAPI';
import { apiAddManualFlight, apiEditManualFlight } from '../../add-and-edit-manual-flight/api/FlightInformationAPI';
import {
  getAllIataCodesSuccessActionCreator,
  getAllIataCodesFailureActionCreator,
  postAddManualFlightSuccessActionCreator,
  postAddManualFlightFailureActionCreator,
  deleteFlightSuccessActionCreator,
  deleteFlightFailureActionCreator,
  putEditManualFlightSuccessActionCreator,
  putEditManualFlightFailureActionCreator,
  getIataCodesSuccessActionCreator,
  getIataCodesFailureActionCreator,
  getManualFlightSuccessActionCreator, getManualFlightFailureActionCreator,
} from '../actions/FlightInformationActions';
import {
  DELETE_FLIGHT_REQUEST,
  ADD_MANUAL_FLIGHT_REQUEST,
  EDIT_MANUAL_FLIGHT_REQUEST,
  GET_ALL_IATA_CODES_REQUEST, GET_IATA_CODES_REQUEST, GET_MANUAL_FLIGHT_REQUEST,
} from '../actions/types/FlightInformationActionTypes';
import { showNotification } from '../../../../../common/notifications/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../locales/locales';
import { languageSelector } from '../../../../../common/redux/selectors/languageSelector';

function* getAllIataCodesWorker(action) {
  try {
    const res = yield call(apiFetchIATAList, action.payload);
    yield put(getAllIataCodesSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getAllIataCodesFailureActionCreator(error));
  }
}

function* getIataCodesWorker(action) {
  try {
    const res = yield call(apiFetchIATAList, action.payload);
    yield put(getIataCodesSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getIataCodesFailureActionCreator(error));
  }
}

function* deleteFlightWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiDeactivateFlight, action.payload);
    yield put(deleteFlightSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, action.payload.isFuture ? 'notification.flight.delete.future.success' : 'notification.flight.delete.active.success'),
    }));
  } catch (error) {
    yield put(deleteFlightFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* postAddManualFlightWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiAddManualFlight, action.payload);
    yield put(postAddManualFlightSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.flights.add.success'),
    }));
  } catch (error) {
    yield put(postAddManualFlightFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* putEditManualFlightWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiEditManualFlight, action.payload);
    yield put(putEditManualFlightSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.flights.edit.success'),
    }));
  } catch (error) {
    yield put(putEditManualFlightFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: error?.response?.data?.message || 'request failed',
    }));
  }
}

function* getManualFlightWorker(action) {
  try {
    const res = yield call(apiFetchManualFlightById, action.payload);
    yield put(getManualFlightSuccessActionCreator(res.data));
  } catch (error) {
    yield put(getManualFlightFailureActionCreator(error));
  }
}

function* flightInformationWatcher() {
  yield takeLatest(DELETE_FLIGHT_REQUEST, deleteFlightWorker);
  yield takeLatest(ADD_MANUAL_FLIGHT_REQUEST, postAddManualFlightWorker);
  yield takeLatest(EDIT_MANUAL_FLIGHT_REQUEST, putEditManualFlightWorker);
  yield takeLatest(GET_ALL_IATA_CODES_REQUEST, getAllIataCodesWorker);
  yield takeLatest(GET_IATA_CODES_REQUEST, getIataCodesWorker);
  yield takeLatest(GET_MANUAL_FLIGHT_REQUEST, getManualFlightWorker);
}

export default flightInformationWatcher;
export {
  getAllIataCodesWorker,
  deleteFlightWorker,
  postAddManualFlightWorker,
  putEditManualFlightWorker,
  getIataCodesWorker,
  getManualFlightWorker,
};
